<template>
  <el-main class="iDalgo-User-New">

    <!-- breadcrumb -->
    <el-row type="flex" class="card align-center">
      <el-col :span="20">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ name: 'users' }">{{ $t('iDalgoCRM.breadcrumb') }}</el-breadcrumb-item>
          <el-breadcrumb-item>{{ $t('iDalgoCRMNew.breadcrumb') }}</el-breadcrumb-item>
        </el-breadcrumb>
      </el-col>
      <el-col :span="4" class="flex-end"><el-button @click="goBack" type="default">{{ $t('actions.cancelButton') }}</el-button></el-col>
    </el-row>
    <div class="mrg-20"></div>

    <!-- form -->
    <el-row type="flex" class="card">
      <el-col class="form">
        <el-form :model="user" :rules="rules" ref="form">
          <el-form-item prop="customer">
            <el-select
              v-model="user.customer"
              :loading="customersLoader"
              filterable
              :placeholder="$t('iDalgoCRMNew.form.customerField')">
              <el-option
                v-for="item in customers"
                :key="item.id"
                :label="item.txt_name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="firstName">
            <el-input v-model="user.firstName" :placeholder="$t('iDalgoCRMNew.form.firstNameField')"></el-input>
          </el-form-item>
          <el-form-item prop="lastName">
            <el-input v-model="user.lastName" :placeholder="$t('iDalgoCRMNew.form.lastNameField')"></el-input>
          </el-form-item>
          <!-- user.username corresponds to an email adress -->
          <el-form-item prop="username">
            <el-input v-model="user.username" :placeholder="$t('iDalgoCRMNew.form.emailField')"></el-input>
          </el-form-item>
          <el-form-item prop="plainPassword">
            <el-input type="password" v-model="user.plainPassword" :placeholder="$t('iDalgoCRMNew.form.passwordField')"></el-input>
          </el-form-item>
          <el-form-item prop="role">
            <el-select v-model="user.role" :placeholder="$t('iDalgoCRMNew.form.roleField')" style="width: 100%;">
              <el-option :label="$t('iDalgoCRMNew.form.roleUser')" value="ROLE_USER"></el-option>
              <el-option :label="$t('iDalgoCRMNew.form.roleAdmin')" value="ROLE_ADMIN"></el-option>
              <el-option :label="$t('iDalgoCRMNew.form.roleSuperUser')" value="ROLE_SUPERUSER"></el-option>
            </el-select>
          </el-form-item>
          <!-- products -->
          <el-form-item :label="$t('iDalgoCRMNew.form.productField')">
            <el-checkbox-group v-model="user.products">
              <el-checkbox label="PRODUCT_SURVEY">{{ $t('iDalgoCRMNew.form.productSurvey') }}</el-checkbox>
              <el-checkbox label="PRODUCT_BAROMETER">{{ $t('iDalgoCRMNew.form.productBarometer') }}</el-checkbox>
              <el-checkbox label="PRODUCT_PLAYERLIST">{{ $t('iDalgoCRMNew.form.productPlayerList') }}</el-checkbox>
              <el-checkbox label="PRODUCT_LIVEBLOG">{{ $t('iDalgoCRMNew.form.productLiveblog') }}</el-checkbox>
              <el-checkbox label="PRODUCT_PREDICTOR">{{ $t('iDalgoCRMNew.form.productPredictor') }}</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          <i-dalgo-button @click="handleSave" :loading="isLoading" style="width: 100%">{{ $t('actions.newButton') }}</i-dalgo-button>
        </el-form>
      </el-col>
    </el-row>

  </el-main>
</template>

<script>
import iDalgoButton from '@/components/iDalgo-Button'
import { mapGetters } from 'vuex'
import { getCopy } from '@/services/tools'

export default {
  name: 'iDalgo-User-New',
  components: {
    iDalgoButton
  },
  computed: {
    ...mapGetters({
      models: 'users/models',
      user: 'users/user',
      isLoading: 'users/isLoading',
      customers: 'customers/customers',
      customersLoader: 'customers/isLoading'
    })
  },
  data () {
    return {
      rules: {
        customer: [
          { required: true, message: this.$t('iDalgoCRMNew.formRules.customer.requiredMessage'), trigger: 'blur' }
        ],
        username: [
          { required: true, message: this.$t('iDalgoCRMNew.formRules.email.requiredMessage'), trigger: 'blur' },
          { min: 3, max: 255, message: this.$t('iDalgoCRMNew.formRules.email.sizeMessage'), trigger: 'blur' },
          { type: 'email', message: this.$t('iDalgoCRMNew.formRules.email.invalidEmail'), trigger: 'blur' }
        ],
        plainPassword: [
          { required: true, message: this.$t('iDalgoCRMNew.formRules.plainPassword.requiredMessage'), trigger: 'blur' },
          { min: 3, max: 255, message: this.$t('iDalgoCRMNew.formRules.plainPassword.sizeMessage'), trigger: 'blur' }
        ],
        role: [
          { required: true, message: this.$t('iDalgoCRMNew.formRules.role.requiredMessage'), trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    async handleSave () {
      this.$refs['form'].validate(async (valid) => {
        if (valid) {
          try {
            await this.$store.dispatch('users/createUser', this.user)
            // user creation succeeded
            this.$notify({
              title: this.$t('iDalgoCRMNew.createNotification.successTitle'),
              message: this.$t('iDalgoCRMNew.createNotification.successMessage'),
              type: 'success'
            })
            this.$router.push({ name: 'users' })
          } catch (e) {
            this.$notify.error({
              title: this.$t('iDalgoCRMNew.createNotification.errorTitle'),
              message: this.$t('iDalgoCRMNew.createNotification.errorMessage')
            })
            this.$store.dispatch('auth/checkStatus', e.response.status)
            throw e
          }
        } else {
          return false
        }
      })
    },
    goBack () {
      this.$router.go(-1)
    }
  },
  beforeDestroy () {
    // when changing page / refreshing, reset user so the next form won't have any residue
    this.$store.commit('users/USER_UPDATED', getCopy(this.models.user))
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.form {
  justify-content: center;
  padding: 26px 0;

  .card {
    padding: $default_padding;
    margin: auto;
  }
}

.el-form {
  display: flex;
  flex-flow: column;
  align-items: center;
  width: 300px;
  padding: $default_padding * 2 0;

  & > * {
    margin: $default_padding / 2;
    width: 100%;
    transition: all 0.2s;
  }

  & > .is-error {
    margin-bottom: $default_padding;
  }

  &:last-child {
    margin-bottom: 0;
  }

}
</style>

<style lang="scss">
.iDalgo-User-New {
  .form {
    .el-form-item {
      display: flex;
      flex-direction: column;

      .el-input {
        font-size: 32px;
        input {
          color: $color1;
          border: none;
          padding: 0;

          &::placeholder {
            color: $text-gray;
          }
        }
      }

      .el-checkbox {
        margin: 0;

        &__label {
          font-size: 16px;
          color: $color1;
          font-family: 'robotoregular';
        }

        &-group {
          display: flex;
          flex-direction: column;
        }
      }

      .el-form-item__label {
        color: $color1;
        font-size: 32px;
        text-align: left;
      }
    }

    .el-button {
      width: 100%;
    }

    .el-icon-info {
      font-size: 16px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/iDalgo-User-New.vue